/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Окно браузера.
   */
  app.MainWindow = app.View.extend({
    el: $(window),
    events: {
      load: 'load',
      scroll: 'scroll',
      resize: 'resize',
      mouseover: 'mouseOver',
      mouseout: 'mouseOut',
      click: 'click',
    },

    /**
     * @inheritDoc
     */
    run: function () {
      this.saveDimensions();
      this.setScrollTop();
      this.debouncedResize = _.debounce(this.onResize.bind(this), 500);
      this.debouncedScroll = _.debounce(this.setScrollTop, 500);
    },

    /**
     * Триггерим событие load.
     */
    load: function () {
      this.trigger('window.load');
    },
    /**
     * Триггерим событие scroll.
     * @param {Event} e
     */
    scroll: function (e) {
      this.trigger('window.scroll', e.currentTarget);
      this.debouncedScroll();
    },
    /**
     * Триггерим событие resize.
     * @param {Event} e
     */
    resize: function (e) {
      this.trigger('window.resize', e.currentTarget);
      this.debouncedResize(e);
    },

    /**
     * Выполняется отложенно при ресайзе
     * @param {Event} e - событие ресайза
     */
    onResize: function (e) {
      this.trigger('window.resize.debounced', e.currentTarget);
      Backbone.trigger('window.resize.debounced');
      this.saveDimensions();
    },

    /** @inheritDoc */
    mouseOver: function(e) {
      this.trigger('window.mouseover', e.target);
    },
    /** @inheritDoc */
    mouseOut: function(e) {
      this.trigger('window.mouseout', e.target);
    },
    /** @inheritDoc */
    click: function(e) {
      this.trigger('window.click', e.target);
    },

    /**
     * Запоминает текущие размеры окна.
     */
    saveDimensions: function () {
      this.height = this.$el.height();
      this.width = this.el.innerWidth;
    },

    /**
     * Получаем ширину окна.
     * @returns {number} ширина окна.
     */
    getWidth: function () {
      return this.width || this.el.innerWidth;
    },

    /**
     * Возвращает высоту окна
     * @returns {number} - высота окна
     */
    getHeight: function () {
      return this.height || this.$el.height();
    },

    /**
     * Запоминает текущую вертикальную позицию окна.
     */
    setScrollTop: function () {
      this.scrollTop = this.$el.scrollTop();
    },

    /**
     * Возвращает текущую вертикальную позицию окна
     * @returns {number} - позиция в px
     */
    getScrollTop: function () {
      return this.scrollTop;
    }
  });
})(jQuery);

}.call(window));